import { Activity } from 'react';

import styles from '../custom-select.module.css';

import { ICONS } from '@ui/icons/types';
import RotatableIcon from '@ui/RotatableIcon/rotatable-icon';
import { TCustomSelectProps } from '../custom-select.types';
import classNames from 'classnames';

const FakeBorder = ({
  lockActiveState,
  menuOpen,
  permanentDropdownIcon,
  hideDropdownIcon = false,
  design,
  disabled,
  status,
}: {
  lockActiveState: boolean;
  menuOpen: boolean;
  permanentDropdownIcon?: boolean;
  hideDropdownIcon?: boolean;
  design?: TCustomSelectProps['design'];
  disabled?: boolean;
  status?: TCustomSelectProps['status'];
}) => {
  return (
    <div
      className={classNames(styles['fake-border'], 'ai-center', 'jc-flex-end', {
        [styles[status || '']]: status,
        [styles['permanent-dropdown-icon']]: permanentDropdownIcon,
        [styles[design || '']]: design,
        [styles['show-fake-border']]: lockActiveState || design === 'standard',
        [styles['disabled']]: disabled,
      })}
    >
      <Activity mode={hideDropdownIcon ? 'hidden' : 'visible'}>
        <div className={`${styles['fake-dropdown-icon']} flex pi-center`}>
          <RotatableIcon name={ICONS.KEYBOARD_ARROW_DOWN} size={12} rotate={menuOpen ? '180deg' : '0'} />
        </div>
      </Activity>
    </div>
  );
};

export default FakeBorder;
